import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path : '/cart',

  /*  Async getComponent is only invoked when route matches   */
  getComponents (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CartList = require('./containers/CartListContainer').default
      const reducer = require('../../store/product').default
      // const CartReducer = require('../../store/cart')

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'product', reducer })

      /*  Return getComponent   */
      cb(null, { category:null, main:CartList })

    /* Webpack named bundle   */
    }, 'cartList')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CartList/index.js